import React, { useEffect } from "react";
import { HeroReuse } from "../../components/common/HeroReuse";
import CoreValues from "../../components/sections/aboutUs/CoreValues";
import Team from "../../components/sections/aboutUs/Team";
import OurStory from "../../components/sections/aboutUs/OurStory";
import { Link, useLocation } from "react-router-dom";
import aboutUsimg from "../../assets/images/High Res-03.png";

const AboutUs = () => {
  const location = useLocation();

  useEffect(() => {
    const sectionId = location.hash.substring(1);
    const section = document.getElementById(sectionId);
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 100,
        behavior: "smooth",
      });
    }
  }, [location]);

  return (
    <>
      <div className="flex flex-col gap-16">
        <HeroReuse
          Subtitle="ABOUT US"
          Title="We change the way you do Regulatory Compliance"
          boldHead
          Description={
            "helps you automate, monitor, and comply smarter. Welcome to your new go-to solution for all things regulatory."
          }
          // ButtonText="Request a Demo Today"
          imgUrl={aboutUsimg}
        />
        <div
          id="our-story"
          className="bg-[#F1EFF1]/40 px-4 sm:px-16 lg:px-20 py-16 sm:py-20"
        >
          <OurStory />
        </div>
        <CoreValues />
      </div>
      <div className="flex flex-col gap-8 md:gap-20 lg:gap-16 pt-16">
        <div className="bg-[#F1EFF1]/40">
          <Team />
        </div>
        <div className="w-full bg-[#67DC7A] md:bg-darkPurple lg:bg-[#67DC7A] text-darkGray md:text-white lg:text-darkGray px-4 py-16 sm:py-20 lg:py-16">
          <div
            className={`flex flex-col items-center justify-center gap-8 space-y-3`}
          >
            <div className="flex flex-col items-center justify-center gap-4">
              <span
                className="block sm:hidden lg:block font-poppins font-bold text-2xl lg:text-[32px] "
                style={{ letterSpacing: "-2%" }}
              >
                Vacancies
              </span>
              <h2
                className={`font-poppins text-center font-bold sm:font-semibold leading-10 text-2xl sm:text-4xl sm:leading-[44px] tracking-tight max-w-2xl`}
              >
                Join us in building the first truly global Regulatory Compliance
                platform
              </h2>
              <p
                className={`text-base sm:text-lg font-poppins font-normal leading-7 text-center max-lg:w-[320px] lg:text-darkBlue`}
              >
                We are growing quickly! Check out our open roles and apply
                today.
              </p>
            </div>
            <button
              className={`w-auto flex items-center py-4 px-9 !mt-0 text-lg font-bold rounded-full border-2 text-white md:text-primary lg:text-white border-darkPurple md:border-white lg:border-darkPurple bg-darkPurple md:bg-white lg:bg-darkPurple transition-all`}
            >
              <Link
                to="/careers"
                className="font-poppins leading-6 text-lg font-semibold"
              >
                See Open Vacancies
              </Link>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
